import {Rarity, Warehouse} from './../core/entities/entities';
import { Injectable } from '@angular/core';
import {HttpServiceBase, Page} from '../core/services/HttpServiceBase';
import {HttpService} from '../core/services/http.service';
import {CardConditionService} from './card-condition.service';
import {isNullOrUndefined} from "util";
import {LanguageService} from './language.service';
import {environment} from '../../environments/environment';
import {Card, DTO, Edition, PriceRule, ProductDetail, StockRule, StockRulePreference} from '../core/entities/entities';
import {Observable} from 'rxjs/Observable';
import {WarehouseService} from './warehouse.service';
import * as Rx from 'rxjs/Rx';
import {Response} from '@angular/http';
import {ErrorType} from '../core/services/error.service';
import {PriceRuleDetailDTO} from './price-rule.service';
import {isNumeric} from "rxjs/util/isNumeric";
import {RarityService} from './rarity.service';
import {HoloService} from './holo.service';

export class MultipleStockRuleDTO {
  id: any;
  categoryId: any;
  brandId: any;
  holoId: any;
  firstEdition: boolean;
  shadowless: boolean;
  staff: boolean;
  signed: boolean;
  stamped: boolean;
  inked: boolean;
  altered: boolean;
  foil: boolean;
  conditionId: number;
  cardId: number[] = [];
  languageId: number;
  rarityId: number[] = [];
  editionId: number[] = [];
  minStockQuantity: number;
  maxStockQuantity: number;
  warehouseId: number[] = [];
  warehouse?: Warehouse;
  preferences: StockRulePreference[] = [];
  editions: Edition[] = [];
  cards: ProductDetail[] = [];
  minPrice: number = 0;
  maxPrice: number = 1000000000;
}

@Injectable()
export class StockRuleService extends HttpServiceBase<StockRule> {
  getUrl(): string {
    return 'warehouserule';
  }

  protected init(): void {
  }

  getCleanInstance(): StockRule {
    return new StockRule();
  }

  private preferenceFormJson(json): StockRulePreference{
    const me = this;
    const item: StockRulePreference = Object.assign(new StockRulePreference(), json.combination);

    if(item){

      if(!isNullOrUndefined(json.combination)) {
        if (!isNullOrUndefined(json.combination.language)) {
          item.language = this.languageService.fromJson(item.language);
        }
        if (!isNullOrUndefined(json.combination.condition)) {
          item.condition = this.cardCondService.fromJson(item.condition);
        }
        if (!isNullOrUndefined(json.combination.holo)) {
          item.holoId = json.combination.holo.id;
        }
      }
    }
    return item;
  }

  getDTOfromRule( rule: StockRule){
    let dto: MultipleStockRuleDTO = new MultipleStockRuleDTO();
    dto.editions = [];
    dto.editionId = [];
    dto.cards = [];
    dto.cardId = [];
    dto.id = rule.id;
    dto.firstEdition = rule.combination.firstEdition;
    dto.shadowless = rule.combination.shadowless;
    dto.staff = rule.combination.staff;
    dto.preferences = rule.preferences;
    dto.altered = rule.combination.altered;
    dto.signed = rule.combination.signed;
    dto.stamped = rule.combination.stamped;
    dto.inked = rule.combination.inked;

    dto.foil = rule.combination.foil;
    dto.maxStockQuantity = rule.maxStockQuantity;
    dto.minStockQuantity = rule.minStockQuantity;
    dto.minPrice = rule.minPrice;
    dto.maxPrice = rule.maxPrice;
    if(rule.values.warehouseId)
      dto.warehouseId = rule.values.warehouseId.map( w => w.id);

    dto.holoId = rule.combination.holo ? rule.combination.holo.id : null;
    dto.conditionId = rule.combination.condition ? rule.combination.condition.id : null;
    dto.languageId = rule.combination.language ? rule.combination.language.id : null;
    if( rule.values.cardId && rule.values.cardId.length > 0){

      dto.cards = rule.values.cardId;
      dto.cardId = rule.values.cardId.map( cd => cd.id);
    }else {
      dto.editions = rule.values.editionId;
      dto.editionId = rule.values.editionId.map( cd => cd.id);
    }

    dto.rarityId = rule.values.rarityId.filter(r => r != null).map(r => r.id);
    return dto;


  }

  public fromJson(json): StockRule {
    const me = this;
    const item: StockRule = Object.assign(this.getCleanInstance(), json);

    if(item){
      if(json )
      {
        if(json.minimunStockQuantity && isNullOrUndefined(item.minStockQuantity)){
          item.minStockQuantity = json.minimunStockQuantity;
        }else {
          json.minimunStockQuantity = undefined;
        }
      }

      if(item.preferences){
        item.preferences = json.preferences.map(p => me.preferenceFormJson(p));
      }

      if(isNullOrUndefined(item.minStockQuantity)){
        item.minStockQuantity = 0;
      }

      if(!isNullOrUndefined(item.combination)){
        if(!isNullOrUndefined(item.combination.language)){
          this.languageService.loadById(item.combination.language.id).subscribe( i=> item.combination.language =i);
        }
        if(!isNullOrUndefined(item.combination.condition)){
          this.cardCondService.loadById(item.combination.condition.id).subscribe( i=> item.combination.condition =i );
        }
        if(!isNullOrUndefined(item.combination.holo)){
          this.holoService.loadById(item.combination.holo.id).subscribe( i=> item.combination.holo =i );
        }
      }



      if(item.warehouseId) {
        this.warehouseService.loadById(item.warehouseId).subscribe(i => item.warehouse = i);
      }

      if ( json.rarity ) {
        item.rarity = this.rarityService.fromJson(json.rarity);
        item.rarityId = item.rarity  ? item.rarity.id : null;
      } else if (  !isNullOrUndefined(item.rarityId) ){
        this.rarityService.loadById(item.rarityId).subscribe( ret =>  item.rarity);
      }

      item.values = JSON.parse(item.multipleValue);
      if(item.values){


        item.values.editionId = item.values.editionId.map( ed => Object.assign(new Edition(), ed));
        item.values.cardId = item.values.cardId.map( c => {
          const card = Object.assign(new ProductDetail(), c);
          // Rules saved before the card_data -> cardData rename keep the old key in
          // their persisted multipleValue JSON. Carry it over so the stored rows
          // render instead of throwing on an undefined cardData.
          if (!card.cardData && c && c['card_data']) {
            card.cardData = c['card_data'];
          }
          return card;
        });
        item.values.warehouseId = item.values.warehouseId.map(w => Object.assign(new Warehouse(), w));
        item.values.rarityId = item.values.rarityId.map( r => {
          if (isNumeric(r)) {
            const rarity: Rarity = this.rarityService.data.find( cr => cr.id ==  r);
            if( rarity ) {
              return rarity;
            }
          }

          return r;
        });
      }
    }
    return item;
  }

  public fromEntity(en: StockRule): any {
    const json = super.fromEntity(en);
    if(json && en.warehouse && en.warehouse.virtual){
      json.preferences = null;
    }

    return json;
  }

  insert(dto: MultipleStockRuleDTO) : Rx.Observable<StockRule>{
    const me = this;

    let reqDTO = new MultipleStockRuleDTO();
    Object.keys(dto).forEach(key => {
      if(dto[key] == 'null')
      {
        dto[key] = null;

      }

      if(!isNullOrUndefined(dto[key])){
        reqDTO[key]= dto[key];
      }

    });
    return Rx.Observable.create((observer: any) => {
      me.http.post(me._url, reqDTO)
        .map(function (res: Response) {
          const body: DTO = <DTO> res.json();
          const err: Error = me.getError(body);
          if (err) {
            observer.throw(me.handleError(err, ErrorType.SUBMIT));
            return;
          }
          observer.next(me.onAddOrUpdate(body.data || null));
        }).catch(error => observer.throw(me.handleError(error, ErrorType.HTTP))).subscribe();

    });
  }

  save(dto: MultipleStockRuleDTO)  : Rx.Observable<StockRule>{
    const me = this;
    let reqDTO = new MultipleStockRuleDTO();
    Object.keys(dto).forEach(key => {
      if(dto[key] == 'null')
      {
        dto[key] = null;
      }

      if(!isNullOrUndefined(dto[key])){
        reqDTO[key]= dto[key];
      }

    });
    return Rx.Observable.create((observer: any) => {
      me.http.put(this._url + '/' + dto.id, reqDTO)
        .map(function (res: Response) {
          const body: DTO = <DTO> res.json();
          const err: Error = me.getError(body);
          if (err) {
            observer.throw(me.handleError(err, ErrorType.SUBMIT));
            return;
          }
          observer.next(me.onAddOrUpdate(body.data || null));
        }).catch(error => observer.throw(me.handleError(error, ErrorType.HTTP))).subscribe();

    });

  }

  search( filters: {}): Observable<Page<StockRule>> {
    const me = this;
    let url = me._url ;

    if( filters){
      filters =  Object.keys(filters)
        .filter(k => !isNullOrUndefined(filters[k]) && 'null' != filters[k] && 'undefined' != filters[k] )
        .reduce((previousValue, k) => {
          previousValue[k]=filters[k];
          return previousValue;
        },{});
    }

    return Rx.Observable.create((observer: any) => {
      me.loadPage(filters, undefined, me._url ).subscribe(ret => observer.next(ret));
      //me.httpCall('get', url).subscribe(ret => observer.next(me.setItems(<any[]>ret || null)));
    });
  }

  constructor(protected http: HttpService, private cardCondService: CardConditionService, private languageService: LanguageService, private warehouseService: WarehouseService , private rarityService: RarityService, private holoService: HoloService ) {
    super(http);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/stock-rule.service.ts